import React, { useState } from "react";
import { SKIN_THEMES, FONT_UI, FONT_HEADING } from "./constants";

export default function Header({
  skin,
  skinId,
  onSkinChange,
  dashboardData = {},
  onLogout,
  setSidebarOpen,
}) {
  const [profileOpen, setProfileOpen] = useState(false);

  const companyName = dashboardData?.company_name || "Admin";

  const initials = companyName
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

  return (
    <header className="sticky top-0 z-50 flex h-16 items-center justify-between border-b bg-white px-4 shadow-sm md:px-7">
      
      {/* LEFT SIDE */}
      <div className="flex items-center gap-3">
        {/* Mobile Hamburger */}
        <button
          onClick={() => setSidebarOpen(true)}
          className="flex rounded-lg px-3 py-1.5 text-white lg:hidden"
          style={{ background: skin.accent }}
        >
          ☰
        </button>

        {/* Title */}
        <div className="flex items-center gap-3">
          <div
            className="h-7 w-1 rounded"
            style={{ background: skin.gradient }}
          />

          <div>
            <h1
              className="text-sm font-semibold text-slate-900 md:text-base"
              style={{ fontFamily: FONT_HEADING }}
            >
              Admin Dashboard
            </h1>

            <p className="text-xs text-slate-400">
              Eblackdog Patrol Management
            </p>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="flex items-center gap-4">

        {/* Theme Selector */}
        <div className="flex items-center gap-2">
          <span className="hidden text-xs text-slate-400 md:block">
            Theme
          </span>

          {SKIN_THEMES.map((s) => (
            <button
              key={s.id}
              title={s.label}
              onClick={() => onSkinChange(s.id)}
              className={`rounded-full transition ${
                skinId === s.id
                  ? "h-5 w-5 border-2 border-slate-700"
                  : "h-4 w-4 border border-transparent"
              }`}
              style={{ background: s.gradient }}
            />
          ))}
        </div>

        {/* Divider */}
        <div className="h-6 w-px bg-slate-200" />

        {/* PROFILE */}
        <div className="relative">
          <button
            onClick={() => setProfileOpen((o) => !o)}
            className="flex items-center gap-2 rounded-lg px-2 py-1 hover:bg-slate-100"
          >
            {/* Avatar */}
            <div
              className="flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-white"
              style={{ background: skin.gradient }}
            >
              {initials}
            </div>

            {/* Name */}
            <div className="hidden text-left md:block">
              <p className="text-sm font-semibold text-slate-800">
                {companyName}
              </p>
              <p className="text-xs text-slate-400">Administrator</p>
            </div>

            {/* Arrow */}
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#94a3b8"
              strokeWidth="2"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>

          {/* DROPDOWN */}
          {profileOpen && (
            <div className="absolute right-0 mt-2 w-64 overflow-hidden rounded-xl border bg-white shadow-lg">
              
              {/* Header */}
              <div className="flex items-center gap-3 border-b p-4">
                <div
                  className="flex h-10 w-10 items-center justify-center rounded-full text-white"
                  style={{ background: skin.gradient }}
                >
                  {initials}
                </div>

                <div>
                  <p
                    className="text-sm text-slate-900"
                    style={{ fontFamily: FONT_HEADING }}
                  >
                    {companyName}
                  </p>
                  <p className="text-xs text-slate-400">
                    Administrator
                  </p>
                </div>
              </div>

              {/* Details */}
              <div className="space-y-2 px-4 py-3 text-sm">
                <InfoRow label="Email" value={dashboardData?.admin_email} />
                <InfoRow label="Phone" value={dashboardData?.company_phone} />
                <InfoRow label="Address" value={dashboardData?.company_address} />
              </div>

              {/* Logout */}
              <button
                onClick={onLogout}
                className="w-full border-t px-4 py-3 text-left text-sm text-red-500 hover:bg-red-50"
              >
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

/* ========================= */
/* Small Reusable Component  */
/* ========================= */

function InfoRow({ label, value }) {
  return (
    <div>
      <p className="text-[10px] font-semibold uppercase text-slate-400">
        {label}
      </p>
      <p className="text-sm text-slate-800">
        {value || "—"}
      </p>
    </div>
  );
}